// extracted by mini-css-extract-plugin
export var localeSelector = "_at-0";